import type { ApiError as ApiErrorBody } from '@/types/api'

/** Ошибка API в формате {code, message, errors} (спецификация 6.4). */
export class ApiError extends Error {
  constructor(
    public status: number,
    public code: number,
    message: string,
    public errors?: unknown,
    /** Сколько секунд ждать до повтора; приходит с 429. */
    public retryAfter?: number,
  ) {
    super(message)
    this.name = 'ApiError'
  }
}

export const BASE = import.meta.env.VITE_API_BASE ?? '/api/v1'

export async function api<T>(path: string, init: RequestInit & { token?: string } = {}): Promise<T> {
  const { token, headers, ...rest } = init
  const res = await fetch(`${BASE}${path}`, {
    ...rest,
    headers: {
      Accept: 'application/json',
      ...(rest.body ? { 'Content-Type': 'application/json' } : {}),
      ...(token ? { Authorization: token } : {}),
      ...headers,
    },
  })
  if (res.status === 204) return undefined as T
  const body = (await res.json().catch(() => null)) as (T & ApiErrorBody) | null
  if (!res.ok) {
    const retry = (body as { retry_after?: number } | null)?.retry_after
    throw new ApiError(res.status, body?.code ?? 0, body?.message ?? `${res.status}: ${res.statusText}`, body?.errors, retry)
  }
  return body as T
}

export interface VersionInfo {
  version: string
  api: number
  env: string
  /** Настроен ли поиск гифок: без ключа Klipy вкладку не показываем. */
  gifs?: boolean
}

export const getVersion = () => api<VersionInfo>('/version')
export const getGateway = () => api<{ url: string }>('/gateway')
